import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import api from '../../services/api';

const OrganizationSelector = ({ open, onSelect, onClose }) => {
  const [organizacoes, setOrganizacoes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (open) {
      carregarOrganizacoes();
    }
  }, [open]);

  const carregarOrganizacoes = async () => {
    try {
      setLoading(true);
      // Buscar organizações da API
      const response = await api.get('/user-organizations');
      setOrganizacoes(response.data.organizacoes || []);
    } catch (error) {
      setOrganizacoes([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = async organizacao => {
    try {
      await api.post('/user-organizations/select', {
        organizationId: organizacao._id,
      });
      onSelect(organizacao);
    } catch (error) {}
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      disableRestoreFocus
    >
      <DialogTitle align="center">Selecione uma organização</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        ) : organizacoes.length > 0 ? (
          <List>
            {organizacoes.map((org, index) => (
              <ListItem key={org._id || org.id || index} disablePadding>
                <ListItemButton
                  onClick={() => handleSelect(org)}
                  sx={{
                    borderRadius: 1,
                    mb: 1,
                    border: 1,
                    borderColor: 'divider',
                  }}
                >
                  <ListItemText
                    primary={org.name || 'Organização sem nome'}
                    secondary="Clique para selecionar"
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        ) : (
          <Box p={3} textAlign="center">
            <Typography color="text.secondary">
              Nenhuma organização encontrada
            </Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default OrganizationSelector;
